import React from 'react';
import {
  FormTab,
  TextField,
  ReferenceField,
  ReferenceManyField,
  Datagrid,
  DeleteButton,
} from 'react-admin';
import CreateRelatedButton from '../components/CreateRelatedButton';
import { isProductiveRule } from './regla-utils';

const ReglaExcepcionesTab = ({ ...props }) => {
  const _isProductiveRule = isProductiveRule(props);
  return (
    <FormTab label="resources.regla.tabs.excepciones" path="excepciones" {...props}>
      {!_isProductiveRule && (
        <CreateRelatedButton
          reference="excepciones"
          refFieldName="idRegla"
          label="resources.regla.buttons.crearExcepcion"
        />
      )}
      <ReferenceManyField
        filter={{ deleted: false }}
        addLabel={false}
        reference="excepciones"
        target="idRegla"
        sort={{ field: "idPrestacion", order: "DESC" }}
      >
        <Datagrid rowClick={null}>
          <TextField source="idPrestacion" />
          <ReferenceField
            label="resources.prestaciones.fields.descripcion"
            source="idPrestacion"
            reference="prestaciones"
            link={false}
          >
            <TextField source="descripcion" />
          </ReferenceField>
          {!_isProductiveRule && (
            <DeleteButton mutationMode="optimistic" redirect={false} />
          )}
        </Datagrid>
      </ReferenceManyField>
    </FormTab>
  );
};

export default ReglaExcepcionesTab;
